<template>
  <section class="shark">
    <div v-if="showModal" class="overlay">
      <div @submit.prevent="preRegister" class="modal-game">
        <form>
          <div class="form-group">
            <input
              type="text"
              v-model="userName"
              placeholder="Username"
              class="form-control"
              id="username"
              required
            />
          </div>
          <div class="form-group">
            <input
              type="email"
              v-model="email"
              placeholder="Email"
              class="form-control"
              id="email"
              required
            />
          </div>
          <div v-if="error" class="form-group error">
            <p>Entered email address is not valid</p>
          </div>
          <div class="form-group mb-0">
            <button type="submit" class="btn btn-primary">Play Sharkman!</button>
          </div>
        </form>
      </div>
    </div>
    <div class="d-flex">
      <div class="game-container">
        <GameWindow
          v-if="isLoading"
          :name="userName"
          :email="email"
          @scores="getScore"
          @loaded="showLoader = false"
        />
        <div v-if="showLoader" class="loader">
          <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
      <div class="scores">
        <div class="header">
          <h2>Top players</h2>
        </div>
        <ul class="list-unstyled">
          <li v-for="score in scores" :key="score.id" :title="score.email">
            {{ score.name }}
            <span class="ml-auto">{{ score.score }}</span>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import GameWindow from './GameWindow';
export default {
  components: {
    GameWindow,
  },
  data: () => ({
    scores: [],
    userName: '',
    email: '',
    showModal: true,
    error: false,
    isLoading: false,
    showLoader: false,
  }),
  methods: {
    preRegister() {
      this.error = false;
      const emailRegex = /^[a-zA-Z0-9._-]+@(comstream\.eu|comstream\.se)$/;
      if (emailRegex.test(this.email)) {
        this.showModal = false;
        this.showLoader = true;
        this.isLoading = true;
      } else {
        this.error = true;
      }
    },
    getScore() {
      axios
        .get('https://jobshark.eu/api/v1/external/sharkman/getscore', {
          method: 'get',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(res => {
          this.scores = res.data;
        });
    },
  },
  mounted() {
    this.getScore();
  },
};
</script>

<style lang="scss" scoped>
.shark {
  background-color: #1c1e21;
  height: 100vh;
  overflow-x: hidden;
  .d-flex {
    height: 100vh;
    align-items: center;
  }
  .game-container {
    position: relative;
    width: 80%;
    height: 100vh;
    background: #000;
    display: flex;
    align-items: center;
  }
  .scores {
    flex: 1;
    align-self: flex-start;
    .header {
      background: #242526;
      color: #fff;
      padding: 12px;
      text-transform: uppercase;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      margin-bottom: 12px;
      h2 {
        font-weight: 700;
        margin-bottom: 0;
        font-size: 18px;
      }
    }
    .list-unstyled {
      li {
        align-items: center;
        display: flex;
        color: #fff;
        border-bottom: 1px dotted rgba(255, 255, 255, 0.4);
        padding: 6px 12px;
      }
    }
  }
  .overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    .modal-game {
      padding: 50px;
      width: 540px;
      background-color: #1c1e21;
      border-radius: 12px;
      .form-group {
        .form-control {
          background: #242526;
          border-radius: 22px;
          padding: 28px 12px;
        }
        .btn-primary {
          border-radius: 22px;
          width: 72%;
          display: block;
          margin: 0 auto;
          padding: 15px 12px;
          font-weight: 700;
          font-size: 18px;
          background: rgba(0, 0, 0, 0.4);
          color: #ffff33;
          border: none;
        }
        &.error {
          background: #ef4444;
          color: #fff;
          padding: 8px 22px;
          font-size: 14px;
          border-radius: 12px;
          p {
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .loader {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    .lds-ring {
      display: inline-block;
      position: relative;
      width: 80px;
      height: 80px;
    }
    .lds-ring div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 64px;
      height: 64px;
      margin: 8px;
      border: 8px solid #fff;
      border-radius: 50%;
      animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: #fff transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
      animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
      animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
      animation-delay: -0.15s;
    }
    @keyframes lds-ring {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}
</style>
